export default __webpack_public_path__ + "static/media/pic_1.37d4a41a.png";